import { render, staticRenderFns } from "./_Roles.vue?vue&type=template&id=394a96d4&scoped=true&"
import script from "./_Roles.vue?vue&type=script&lang=js&"
export * from "./_Roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a96d4",
  null
  
)

export default component.exports